const orderRoutes = [
  {
    path: '/order/template',
    name: 'order.sidebar_template',
    component: () => import('@/views/order/template/TemplateList')
  }
]
export default orderRoutes
